import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-warning",
  "use": "svg-warning-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" id=\"svg-warning\"><path d=\"m12 8v5m0 3h0m9-4c0 5-5 9-9 9s-9-4-9-9 4-9 9-9 9 4 9 9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol